<template>
  <div>
    <PageHeader>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$t('Fault.steamingOven')" name="steamingOven"></el-tab-pane>
        <el-tab-pane :label="$t('Fault.refrigerator')" name="refrigerator"></el-tab-pane>
      </el-tabs>
    </PageHeader>
    <CardContainer>
      <CommonForm @search="formSearch" :form-json="formjson" />
      <!--    :data="tableData"-->
      <!--    :total="total"-->
      <CommonTable
        ref="table"
        :data="tableData"
        :total="total"
        @change="handleTableChange"
        :operation="operation"
        @operation="handleOperation"
        :table-json="tablejson"
      >
      </CommonTable>
      <FaultDetail :visible.sync="visible" :row="row"></FaultDetail>
    </CardContainer>
  </div>
</template>

<script>
import formjson from './Model/Formjson.Index'
import tablejson from './Model/Tablejson.Index'
import formTableMixin from '@/mixins/formTableMixin'
import getRoleFromPath from '@/mixins/getRoleFromPath'
import { getRoleByOperationCode } from '@/authorized'
import { formatNumWithComma } from '@/utils/utils'
import FaultDetail from './FaultDetail'
export default {
  mixins: [formTableMixin, getRoleFromPath],
  components: {
    FaultDetail
  },
  data() {
    return {
      formjson,
      tablejson,
      operation: [
        {
          name: this.$t('Common.detail'),
          icon: 'icon-detail_16',
          type: 'detail'
          // hide: () => {
          //   return !this.detailRole
          // }
        }
      ],
      visible: false,
      queryApi: this.$api.fault.fault_list,
      row: {},
      activeName: 'steamingOven'
    }
  },
  computed: {
    /********* 权限 ***********/
    // this.role 计算属性通过mixins: [getRoleFromPath] 注入
    // 导出权限
    roleChildList() {
      return this.role.childList
    },
    // 查询的权限
    listRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'query')
      return val ? val.isPermission == 'Y' : false
    },
    // 故障描述的权限
    detailRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'detail')
      return val ? val.isPermission == 'Y' : false
    }
    /********* 权限 ***********/
  },
  created() {},
  methods: {
    formatNumWithComma,
    formSearch(data, pageObj) {
      if (!data) {
        data = this.cacheData
      }
      data = {
        ...data,
        productType: 'steamingOven'
      }
      this.search(data, pageObj, this.queryApi)
    },
    handleDetail(row) {
      this.row = {
        ...row,
        productType: 'steamingOven'
      }
      this.visible = true
    },
    handleOperation(data) {
      const { type, row } = data
      switch (type) {
        case 'detail':
          this.handleDetail(row)
          break
      }
    },
    handleClick(val) {
      if (this.activeName === 'refrigerator') {
        const { href } = this.$router.resolve({
          name: 'FaultRefrigerator'
        })
        window.open(href, '_self')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.recipe-static-div {
  margin-bottom: 24px;
  .static-div {
    .static-top {
      margin-bottom: 80px;
      .title {
        color: #666666;
        font-size: 16px;
        line-height: 24px;
      }
      .totalData {
        font-family: Barlow-SemiBold;
        font-size: 36px;
        font-weight: 600;
        color: #333333;
        line-height: 44px;
      }
    }
    .static-bottom {
      .addData {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .addData-tips {
          color: #666666;
          line-height: 22px;
          padding-right: 8px;
        }
        .addData-data {
          font-size: 20px;
          font-weight: 600;
          color: #333333;
          line-height: 28px;
        }
        .static-icon {
          //margin-right:24px;
        }
      }
    }
  }
}
.device-add-count {
  width: 100%;
  height: 200px;
}
</style>
